import codeimg from "../../image/code.jpeg";
import Aos from "../../components/aos/aos";
import { Link } from "react-router-dom";
// import Observer from "../components/observer/observer";
import ProgressBar from "./progress";
import { useEffect, useState, useRef } from 'react';
const Skill = () => {
    const [frontend, setfrontend] = useState(false);
    const [backend, setbackend] = useState(false);
    const [database, setdatabase] = useState(false);
    
    const frontEndRef = useRef(null);
    const backEndRef = useRef(null);
    const databaseRef = useRef(null);

    useEffect(() => {
        const Frontendobserver = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setfrontend(true);
                        
                    }else{
                        setfrontend(false); 
                        
                    }
                });
            },
            
        );

        Frontendobserver.observe(frontEndRef.current);
        const backendobserver = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setbackend(true);
                        
                    }else{
                        setbackend(false); 
                    }    
                });
            },
            
        );

        backendobserver.observe(backEndRef.current);
        const databaseobserver = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setdatabase(true);
                        
                    }else{
                        setdatabase(false); 
                    }
                });
            },
            
        );

        databaseobserver.observe(databaseRef.current);
        return () => {
            Frontendobserver.disconnect();
            backendobserver.disconnect();
            databaseobserver.disconnect();
        };
    }, []);

    useEffect(() => {
        
            Aos(1000);
        
    }, []);

    return (

        <div className="relative flex justify-center items-center w-full h-full md:my-40 my-[250px]">
            <div className=" absolute w-full   rounded-lg bg-black/30 backdrop-blur shadow-md shadow-white h-auto py-4 px-4 flex flex-col space-y-4 justify-center items-center">
                <div className="text-3xl font-extrabold font-mono text-white" data-aos="fade-down"> <span className='text-yellow-300'>MY</span> SkILLS</div>
                <div className="text-xl text-white font-sans md:px-2 flex flex-wrap w-full md:space-x-8 space-y-4 md:space-y-0 justify-center" data-aos="zoom-in">
                    <div className="flex flex-col py-2 px-2 justify-center  w-[300px] " data-aos="fade-left" ref={frontEndRef}>
                        <div className="font-bold">Front-End Development</div>
                        <div className="flex flex-col space-y-2 w-full">
                            <div className="w-full">
                                <div className="font-bold text-gray-500">HTML</div>
                        <ProgressBar value={frontend?"90":"0"} />
                            </div>
                            <div className="w-full">
                                <div className="font-bold text-gray-500">CSS</div>
                                <ProgressBar value={frontend?"97":"0"} />
                            </div>
                            <div className="w-full">
                                <div className="font-bold text-gray-500">TAILWIND CSS</div>
                                <ProgressBar value={frontend?"92":"0"} />
                            </div>
                            <div className="w-full">
                                <div className="font-bold text-gray-500">JAVASCRIPT/JQUERY</div>
                                <ProgressBar value={frontend?"89":"0"} />
                            </div>
                            <div className="w-full">
                                <div className="font-bold text-gray-500">REACT</div>
                                <ProgressBar value={frontend?"88":"0"} />
                            </div>

                        </div>
                    </div>
                    <div className="flex flex-col py-2 px-2  w-[300px] " data-aos="fade-up" ref={backEndRef}>
                        <div className="font-bold">Back-end Development</div>
                        <div className="flex flex-col space-y-2 w-full">
                            <div className="w-full">
                                <div className="font-bold text-gray-500">PHP</div>
                                <ProgressBar value={backend?"90":"0"} />
                            </div>
                            <div className="w-full">
                                <div className="font-bold text-gray-500">LARAVEL</div>
                                <ProgressBar value={backend?"97":"0"} />
                            </div>


                        </div>
                    </div>
                    <div className="flex flex-col py-2 px-2 w-[300px]" data-aos="fade-up" ref={databaseRef}>
                        <div className="font-bold">Database management</div>
                        <div className="flex flex-col space-y-2 w-full">
                            <div className="w-full">
                                <div className="font-bold text-gray-500">MYSQL</div>
                                <ProgressBar value={database?"90":"0"} />
                            </div>



                        </div>
                    </div>

                </div>
                <Link reloadDocument data-aos="fade-up" to="/skills" className='bg-yellow-500 px-2 py-2 text-white font-bold rounded-lg justify-self-start'>View Details</Link>
            </div>
            <img src={codeimg} alt="code" className=" rounded-lg h-[300px] w-full" />
        </div>
    );
}

export default Skill;